import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getTeam, saveTeam } from "./../../services/teamService";

class TeamForm extends Form {
  state = {
    data: { id: -1, name: "", logo: "", addInf: "" },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required(),
    logo: Joi.string().allow(""),
    addInf: Joi.string().allow("")
  };

  async componentDidMount() {
    const { match, history } = this.props;

    const teamId = match.params.id;
    if (teamId === "new") return;

    const team = await getTeam(teamId);
    if (!team) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(team) });
  }

  mapToViewModel(team) {
    return {
      id: team.id,
      name: team.name,
      logo: team.logo,
      addInf: team.addInf
    };
  }

  doSubmit = async () => {
    await saveTeam(this.state.data);
    this.props.history.push("/teams");
  };

  render() {
    return (
      <div>
        <h2>Team</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink("/teams", "fa fa-arrow-left", "btn btn-secondary")}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("name", "Name", true)}
          {this.renderInput("logo", "Logo")}
          {this.renderInput("addInf", "Add. Inf.")}
        </form>
      </div>
    );
  }
}

export default TeamForm;



// WEBPACK FOOTER //
// ./src/components/teams/teamForm.jsx